import { Paragraph, TextRun, AlignmentType } from "docx"

export const renderIntroduction = (introduction) => {
  if (!introduction) {
    return []
  }

  return [
    new Paragraph({
      spacing: {
        before: 200,
      },
      alignment: AlignmentType.CENTER,
      children: [
        new TextRun({
          text: introduction,
        })
      ],
    }),
  ]
}
